<template>
	<div class="moonSampleInfoClass">
		<!-- <el-page-header @back="goBack" class="backClass" content="详情页面"> </el-page-header> -->
		<div class="titleNameClass">{{ sampleData.code }}</div>
		<div class="contentDivClass">
			<div class="spanInforDivClass">
				<div class="titleDivClass">
					<span class="titleSpanNameClass">{{ $t('MoonSample.DetectTaskInfo') }}</span>
					<span class="lineRightClass"></span>
				</div>
				<div class="spanInforClass">
					<div class="dataInforDivClass">
						<span class="nameClass">{{ $t('MoonSample.DetectTask') }}</span>
						<span class="valueClass">{{ sampleData.task }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">{{ $t('MoonSample.Location') }}</span>
						<span class="valueClass">{{ sampleData.place }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">{{ $t('MoonSample.Longitude') }}</span>
						<span class="valueClass">{{ sampleData.longitude }}W</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">{{ $t('MoonSample.Latitude') }}</span>
						<span class="valueClass">{{ sampleData.latitude }}S</span>
					</div>
				</div>

				<div class="titleDivClass">
					<span class="titleSpanNameClass">{{ $t('MoonSample.SampleBasicInfo') }}</span>
					<span class="lineRightClass"></span>
				</div>
				<div class="spanInforClass">
					<div class="dataInforDivClass">
						<span class="nameClass">{{ $t('MoonSample.SampleCode') }}</span>
						<span class="valueClass" :title="sampleData.code" style="width: 150px; overflow: hidden; text-overflow: ellipsis; -webkit-box-orient: vertical; display: -webkit-box">{{
							sampleData.code
						}}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">{{ $t('MoonSample.SampleFeature') }}</span>
						<span class="valueClass" :title="sampleData.sampleType" v-html="sampleData.sampleType"></span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">{{ $t('MoonSample.SampleQuantity') }}</span>
						<span class="valueClass">{{ sampleData.num == null ? $t('MoonSample.NoData') : sampleData.num }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">{{ $t('MoonSample.Weight') }}</span>
						<span class="valueClass">{{ sampleData.availableWeight == null ? $t('MoonSample.NoData') : sampleData.availableWeight }}mg</span>
					</div>
				</div>

				<div class="titleDivClass">
					<span class="titleSpanNameClass">{{ $t('MoonSample.SampleClassificationInfo') }}</span>
					<span class="lineRightClass"></span>
				</div>
				<div class="spanInforClass">
					<div class="dataInforDivClass">
						<span class="nameClass">{{ $t('MoonSample.PrimaryCategory') }}</span>
						<span class="valueClass">{{ sampleData.sampleCategory1 }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">{{ $t('MoonSample.SecondaryCategory') }}</span>
						<span class="valueClass">{{ sampleData.sampleCategory2 }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">{{ $t('MoonSample.TertiaryCategory') }}</span>
						<span class="valueClass">{{ sampleData.sampleCategory3 }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">{{ $t('MoonSample.QuaternaryCategory') }}</span>
						<span class="valueClass">{{ sampleData.sampleCategory4 == null ? $t('MoonSample.NoData') : sampleData.sampleCategory4 }}</span>
					</div>
				</div>

				<div class="titleDivClass">
					<span class="titleSpanNameClass">{{ $t('MoonSample.SampleDescriptionInfo') }}</span>
					<span class="lineRightClass"></span>
				</div>
				<div class="spanInforClass">
					<div class="dataInforDivClass">
						<span class="nameClass">{{ $t('MoonSample.Color') }}</span>
						<span class="valueClass">{{ sampleData.color == null ? $t('MoonSample.NoData') : sampleData.color }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">{{ $t('MoonSample.Structure') }}</span>
						<span class="valueClass">{{ sampleData.structure == null ? $t('MoonSample.NoData') : sampleData.structure }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">{{ $t('MoonSample.MineralComposition') }}</span>
						<span class="valueClass" :title="sampleData.mineralComposition">{{ sampleData.mineralComposition == null ? $t('MoonSample.NoData') : sampleData.mineralComposition }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">{{ $t('MoonSample.SampleDescription') }}</span>
						<span class="valueClass" :title="sampleData.content" v-html="sampleData.content"></span>
					</div>
				</div>
			</div>
			<div class="sampleBorrowingClass">
				<div class="titleDivClass">
					<span class="titleSpanNameClass">{{ $t('MoonSample.SampleBorrowingInfo') }}</span>
					<span class="lineRightClass"></span>
				</div>
				<el-table :data="sampleBorrwingTable" stripe :height="300" style="width: 100%">
					<el-table-column prop="companyName" :label="$t('MoonSample.UseUnit')" :width="180" align="left"> </el-table-column>
					<el-table-column prop="usePerson" :label="$t('MoonSample.ResponsiblePerson')"> </el-table-column>
					<el-table-column prop="status" :label="$t('MoonSample.UseStatus')"> </el-table-column>
					<el-table-column prop="borrowWeight" :label="$t('MoonSample.IssuedWeight')"> </el-table-column>
					<el-table-column prop="status" :label="$t('MoonSample.Status')">
						<template #default="scope">
							<span v-if="scope.row.status == 0">{{ $t('MoonSample.DistributionReview') }}</span>
							<span v-if="scope.row.status == 1">{{ $t('MoonSample.PendingDistribution') }}</span>
							<span v-else-if="scope.row.status == 2">{{ $t('MoonSample.BorrowRejected') }}</span>
							<span v-else-if="scope.row.status == 3">{{ $t('MoonSample.ReturnDetection') }}</span>
							<span v-else-if="scope.row.status == 4">{{ $t('MoonSample.DetectionPassed') }}</span>
							<span v-else-if="scope.row.status == 5">{{ $t('MoonSample.DetectionFailed') }}</span>
							<span v-else-if="scope.row.status == 6">{{ $t('MoonSample.Returned') }}</span>
							<span v-else>{{ $t('MoonSample.Borrowing') }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="useType" :label="$t('MoonSample.UseMethod')">
						<template #default="scope">
							<span v-if="scope.row.useType == 1">{{ $t('MoonSample.OriginalUse') }}</span>
							<span v-else-if="scope.row.useType == 2">{{ $t('MoonSample.ConsumptiveUse') }}</span>
							<span v-else-if="scope.row.useType == 3">{{ $t('MoonSample.DestructiveUse') }}</span>
							<span v-else-if="scope.row.useType == 4">{{ $t('MoonSample.ExhibitionEducation') }}</span>
							<span v-else-if="scope.row.useType == 5">{{ $t('MoonSample.Gift') }}</span>
							<span v-else>{{ $t('MoonSample.Other') }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="returnWeight" :label="$t('MoonSample.ReturnWeight')"> </el-table-column>
					<el-table-column prop="returnReviewReason" :label="$t('MoonSample.ReturnDetectionResult')"> </el-table-column>

					<template v-slot:empty>
						<el-empty v-if="sampleBorrwingTable.length == 0" :description="$t('MoonSample.NoData')"></el-empty>
					</template>
				</el-table>

				<div class="titleDivClass">
					<span class="titleSpanNameClass">{{ $t('MoonSample.PhotoSampleInfo') }}</span>
					<span class="lineRightClass"></span>
				</div>
				<div>
					<div style="display: block; text-align: left; margin-bottom: 10px">{{ $t('MoonSample.TotalRecords', { count: sampleImageInfo.length }) }}</div>
					<div class="imgSampleClass">
						<el-carousel style="width: 100%" :active-item-index="activeIndex" @change="handleActiveIndexChange" :interval="4000" type="card" height="400px">
							<el-carousel-item v-for="(item, index) in sampleImageInfo" :key="index">
								<img :src="item.image" style="heigth: 300px; width: 400px" />
								<!-- <img src="./../../../assets/moonsamples/img1.png" /> -->
								<div class="infoDivClass" v-if="activeIndex == index">
									<p class="infoClass" v-html="item.remark2"></p>
								</div>
							</el-carousel-item>
						</el-carousel>
						<!-- <img src="./../../../assets/moonsamples/left.png" @click="leftClickFunc()">
						<img src="./../../../assets/moonsamples/right.png" @click="rightClickFunc()"> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			imgArrTest: [
				{ img: require('./../../../assets/moonsamples/img1.png'), remark: 'wwwww' },
				{ img: require('./../../../assets/moonsamples/img2.png'), remark: 'wwwww11111111' }
			],
			activeIndex: 0,
			sampleImageInfo: [],
			sampleData: '',
			sampleBorrwingTable: []
		}
	},
	mounted() {
		console.log(this.$route.query.obj) // 输出搜索关键词 "vue"
		this.initDataFunc(this.$route.query.obj)
	},
	methods: {
		handleActiveIndexChange(index) {
			this.activeIndex = index
			console.log('当前激活的幻灯片索引:', index)
			// 获取当前激活的幻灯片数据
			const currentItem = this.carouselItems[index]
			console.log('当前激活的幻灯片数据:', currentItem)
		},
		goBack() {
			this.$emit('goBackFunc', 1)
		},
		decryptWithCBC(ciphertextBase64, secretKey, iv) {
			// 1. 将密钥和IV从字符串转为CryptoJS的WordArray
			const keyWordArray = CryptoJS.enc.Utf8.parse(secretKey)
			const ivWordArray = CryptoJS.enc.Utf8.parse(iv)
			// 2. 执行解密
			const decrypted = CryptoJS.AES.decrypt(ciphertextBase64, keyWordArray, {
				iv: ivWordArray,
				mode: CryptoJS.mode.CBC,
				padding: CryptoJS.pad.Pkcs7
			})
			// 3. 将解密结果转为UTF-8字符串
			return decrypted.toString(CryptoJS.enc.Utf8)
		},
		async initDataFunc(row) {
			console.log(row)
			this.sampleData = JSON.parse(row)
			let imageArr = ''
			let remarkArr = ''
			if (this.sampleData.images[0]) {
				imageArr = this.sampleData.images[0].image.split(',')
				if (this.sampleData.images[0].remark) {
					remarkArr = this.sampleData.images[0].remark.split('||')
				}
			}
			this.sampleImageInfo = []
			if (imageArr && imageArr.length > 0) {
				imageArr.forEach((element, index) => {
					this.sampleImageInfo.push({ image: element, remark2: remarkArr[index] ? remarkArr[index] : this.$t('MoonSample.NoDescription') })
				})
			}

			const params = {
				pageSize: 1000,
				pageNum: 1,
				parentCode: row.code
			}
			let res = await this.$http.get(this.$const.moonSample.getMoonSampleBorrowingReturnNew + `?sampleDataId=${this.sampleData.id}`, params)
			if (res && res.code == 200) {
				this.sampleBorrwingTable = res.rows
				// this.totalMoonSample = res.total
				const secretKey = 'naoc123456789012' // 16字节密钥
				const iv = '0987654321abcdef' // 16字节IV
				for (let item of res.rows) {
					if (item.companyName) {
						item.companyName = this.decryptWithCBC(item.companyName, secretKey, iv)
					}
					if (item.usePerson) {
						item.usePerson = this.decryptWithCBC(item.usePerson, secretKey, iv)
					}
				}
				this.moonSampleTableData = res.rows
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.moonSampleInfoClass {
	width: 1200px;
	position: absolute;
	text-align: center;
	left: 25%;
	display: inline-block;
	.backClass {
		height: 40px;
		width: 100%;
		background: linear-gradient(90deg, rgba(251, 251, 251, 0.5) 0%, #f8f8f8 49%, rgba(245, 245, 245, 0.5) 100%);
		line-height: 40px;
	}
	.titleNameClass {
		height: 80px;
		font-family: MicrosoftYaHeiUISemibold;
		font-size: 28px;
		color: #000000;
		line-height: 80px;
		text-align: left;
		font-style: normal;
	}
	.contentDivClass {
		width: 1200px;
		// height: 1196px;
		background: #ffffff;
		border-radius: 4px;
		padding: 24px;
		border: 1px solid rgba(21, 65, 140, 0.2);
		.spanInforDivClass,
		.sampleBorrowingClass {
			display: flex;
			flex-direction: column;
			justify-content: left;
			.titleDivClass {
				display: flex;
				justify-content: left;
				align-items: center;
				height: 60px;
				.titleSpanNameClass {
					// width: 108px;
					height: 19px;
					font-family: ReeJi-BigRuixain, ReeJi-BigRuixain;
					font-weight: normal;
					font-size: 18px;
					color: #15418c;
					line-height: 19px;
					text-align: left;
					font-style: normal;
					font-weight: 600;
				}
				.lineRightClass {
					width: 80%;
					// border-image: linear-gradient(270deg, rgba(21, 65, 140, 0.1), rgba(21, 65, 140, 0.3)) 1 1;
					border-style: dashed;
					border-width: 1px;
					border-color: #abc0e3;
				}
			}
			.spanInforClass {
				display: flex;
				align-items: center;
				justify-content: space-between;
				width: 1100px;
				height: 60px;
				.dataInforDivClass {
					display: flex;
					justify-content: left;
					align-items: center;
					width: 300px;
					.nameClass {
						// width: 120px;
						min-width: 140px;
						padding: 10px 10px;
						height: 40px;
						display: flex;
						align-items: center;
						justify-content: center;
						background: rgba(21, 65, 140, 0.08);
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						text-overflow: ellipsis;
					}
					.valueClass {
						// height: 21px;
						font-family: MicrosoftYaHeiUISemibold;
						font-size: 16px;
						color: #15418c;
						line-height: 21px;
						text-align: left;
						font-style: normal;
						width: 150px;
						word-break: break-all;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: normal;
					}
				}
			}
			.imgSampleClass:hover .infoDivClass {
				display: inline;
			}
			.imgSampleClass {
				display: flex;
				justify-content: center;
				align-items: center;
				.imgInforClass {
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: space-between;
					width: 90%;
					flex-direction: row;
					span {
						width: auto;
						// width: 500px;
						height: 32px;
						background: #15418c;
						border-radius: 16px;
						opacity: 0.5;
						color: #fff;

						padding-right: 15px;
						padding-left: 15px;
						margin-top: 24px;
						line-height: 32px;
						font-size: 14px;
					}
				}

				.infoDivClass {
					width: 100%;
					position: absolute;
					height: 90%;
					background: rgba(0, 0, 0, 0.4);
					right: 0px;
					// padding: 20px 25px;
					display: none;
					.infoClass {
						font-family: '微软雅黑';
						margin: 0px 0 0px 0;
						line-height: 1.5;
						color: #fff;
						text-align: left;
						padding: 10px;
						font-size: 18px;
					}
				}
			}
		}
	}
}
</style>

<style>
.el-carousel__item h3 {
	color: #475669;
	font-size: 14px;
	opacity: 0.75;
	line-height: 200px;
	margin: 0;
}

.el-carousel__item:nth-child(2n) {
	background-color: unset;
	width: auto;
}

.el-carousel__item:nth-child(2n + 1) {
	background-color: unset;
	width: auto;
}
</style>